const BirthControl = Object.freeze({
  PILL_COMBO: 'Pill (Estrogen & Progestin)',
  MINIPILL: 'Pill (Progestin only)',
  PATCH: 'Patch',
  RING: 'Ring',
  IUD: 'IUD'
})

export default BirthControl